import React from 'react';
import PropTypes from 'prop-types';
import { GlobalUXState } from 'components/GlobalUXState';

export const TableEmptyState = ({
  entityName,
  hasActiveFilters = false,
  emptyDescription,
  filterDescription,
  ...rest
}) => (
  <GlobalUXState
    variant={hasActiveFilters ? 'noResults' : 'noData'}
    compact
    description={
      hasActiveFilters
        ? filterDescription || `No ${entityName} match your search.`
        : emptyDescription || `No ${entityName} available yet.`
    }
    {...rest}
  />
);

TableEmptyState.propTypes = {
  entityName: PropTypes.string.isRequired,
  hasActiveFilters: PropTypes.bool,
  emptyDescription: PropTypes.string,
  filterDescription: PropTypes.string,
};

TableEmptyState.defaultProps = {
  hasActiveFilters: false,
  emptyDescription: '',
  filterDescription: '',
};
